.unsubscribe-message{font-weight:700;margin:auto;font-size:20px;text-align:center}
/*# sourceMappingURL=unsubscribe.component-JJQLXH2R.css.map */
